(() => {
  const form = document.getElementById('egift-product-form');
  if (!form) return;
  const quantity = form.querySelector('select[name="quantity"]');
  const app = form.querySelector('.sns-gift-product-container');
  if (!quantity || !app) return;
  let scheduled = false;
  const sync = () => {
    scheduled = false;
    app.querySelectorAll('button').forEach(button => {
      if (button.textContent.trim() === 'ギフト設定をキャンセルする') {
        button.parentElement.hidden = true;
      }
    });
    const control = app.querySelector('[data-testid="gift-quantity"]');
    if (!control) { form.classList.remove('tc-egift--quantity-synced'); return; }
    const matches = control.textContent.trim() === quantity.value;
    form.classList.toggle('tc-egift--quantity-synced', matches);
    if (matches) return;
    const option = app.querySelector(`[data-testid="select-option-${quantity.value}"]`);
    if (option) option.click();
    else control.click();
  };
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(sync);
  };
  quantity.addEventListener('change', schedule);
  new MutationObserver(schedule).observe(app, { childList: true, subtree: true, characterData: true });
  schedule();
})();
